module.exports = __webpack_public_path__ + "img/7.8b13ff72.png";